import React from "react";

export default function CompModal({ comps, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-full max-w-lg rounded-lg shadow-lg p-4 relative mx-2">
       <button
  onClick={onClose}
  className="absolute top-2 right-2 text-white bg-black bg-opacity-60 hover:bg-opacity-90 rounded-full w-8 h-8 flex items-center justify-center text-lg font-bold"
  aria-label="Close"
>
  &times;
</button>


        <h2 className="text-lg font-semibold mb-4">Comparable Vehicles</h2>

        <div className="space-y-4 max-h-[75vh] overflow-y-auto">
          {comps.map((comp, idx) => (
          <div className="relative border rounded p-3 shadow-sm">
  <span className="absolute top-2 left-2 bg-red-600 text-white px-2 py-1 text-xs rounded shadow">
    Sold
  </span>
              <img
                src={comp.imageUrl}
                alt={`${comp.make} ${comp.model}`}
                className="w-full h-40 object-cover rounded mb-2"
              />
              <div className="font-medium">
                {comp.year ?? "Year"} {comp.make ?? "Make"} {comp.model ?? "Model"} {comp.trim ?? ""}
              </div>
              <div className="text-gray-600 text-sm">
                {comp.price != null ? `$${comp.price.toLocaleString()}` : "Price N/A"} •{" "}
                {comp.mileage != null ? `${comp.mileage.toLocaleString()} mi` : "Mileage N/A"}
              </div>
              {/* <div className="text-xs text-gray-500">
                {comp.dealerCity ?? "City"}, {comp.dealerState ?? "State"}
              </div> */}
            </div>
          ))}
        </div>

       <button
  onClick={onClose}
  className="mt-4 px-4 py-2 bg-blue-600 text-white text-sm rounded hover:bg-blue-700"
>
  Close
</button>

      </div>
    </div>
  );
}
